<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              ขอเปลี่ยนแปลงตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอเปลี่ยนแปลงตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            ขอเปลี่ยนแปลงตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            ตัวแทนใต้สังกัดที่ต้องการดำเนินการ
            <span class="required">*</span>
          </div>
          <div class="ps-2 row font-family">
            <div class="col-11" style="padding-right: initial">
              <input
                v-model="this.AgentCode"
                type="text"
                class="field field__input a-field__input fs-6 bla-placeholder"
                style="border-bottom: 1px solid #d0d0d0; font-family: monospace;"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                placeholder="รหัสตัวแทน"
                maxlength="8"
                @change="format(this.AgentCode)"
              />
            </div>
            <div class="col-1" style="padding-left: inherit">
              <font-awesome-icon
                style="
                  color: #0057a8;
                  width: 24px;
                  height: 24px;
                  margin-top: 25px;
                  cursor: pointer;
                "
                :icon="IconSearch"
                @click="Search(this.AgentCode)"
              />
            </div>
            <div v-if="this.AgentPositionCode !== ''" >
              <label class="font-family fs-5 fw-normal blue-1">{{ this.AgentPositionPrename }} {{ this.AgentPositionName }} {{ this.AgentPositionSurname }}</label><br/>
              <label class="font-family fs-5 fw-normal blue-1">ตำแหน่งปัจจุบัน {{ this.AgentPositionTITLE }}</label>
            </div>
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            ดำเนินการเพื่อ<span class="required">*</span>
          </div>
          <div class="font-family fs-5 mt-2 mt-lg-1">
            <v-select
              v-model="this.CHG_TYPE"
              :reduce="(option) => option.value"
              :options="[
                {
                  id: 1,
                  label: 'เลื่อนตำแหน่ง',
                  value: 'PM',
                },
                {
                  id: 2,
                  label: 'ลดตำแหน่ง',
                  value: 'DW',
                },
              ]"
              placeholder="กรุณาระบุตัวเลือก"
              :disabled="disabled"
            />
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
            เปลี่ยนเป็น :
          </div>
          <div class="gray-3 fs-5 font-family">
            ตำแหน่งใหม่<span class="required">*</span>
          </div>
          <div class="font-family fs-5 mt-2 mt-lg-1">
            <v-select
              v-model="CHY_POT"
              :reduce="(option) => option.value"
              :options="ListPosition"
              placeholder="กรุณาเลือกตำแหน่ง"
              :disabled="disabled"
            />
          </div>
        </div>
        <div class="pb-3 pb-lg-3 mt-2 mt-lg-1">
          <div class="gray-3 fs-5 font-family">
            ข้อมูลเพิ่มเติม
          </div>
          <div class="fs-4 font-family">
            <textarea v-model="AD_INFO_DETAIL" class="field field__input a-field__input border-none" style="border-bottom: 1px solid #d0d0d0; resize: none; height: 80px;" aria-label="With textarea" placeholder="ข้อมูลเพิ่มเติม" maxlength="254" :disabled="disabled"></textarea>
          </div>
        </div>
        <div class="col mt-2 mb-2 mb-lg-2">
          <div class="col mt-2 mb-2 mb-lg-1">
            <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()">
              <label class="btn-next">ดำเนินการต่อ</label>
            </button>
          </div> 
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  naem: "ChangePositionView",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5
  },
  data() {
    return {
      IconSearch: faMagnifyingGlass,
      AgentCode: '',
      AgentPositionCode: '',
      AgentPositionPrename: '',
      AgentPositionName: '',
      AgentPositionSurname: '',
      AgentPositionAGENTTYPE: '',
      AgentPositionAG_STATUS: '',
      AgentPositionAG_LEVEL: '',
      AgentPositionAG_STLV_SP: '',
      AgentPositionTITLE: '',
      CHG_TYPE: '',
      CHY_POT: '',
      AD_INFO_DETAIL: '',
      ListPosition: [],
      Loading: true,
      CheckSearch: false,
      disabled: false
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;

        let params = { AGENTCODE: res.data.AGENTCODE };
        http.get("AgencyERequest/Permission?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then(() => { 
          
        }).catch(() => { 
          console.log("Catch Fond")
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
          }).then(() => { 
            this.$router.push("/AgenteService");
          });
        });
      }
      else {
        this.Loading = false;
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => { 
      this.Loading = false; 
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });

    this.AgentCode = this.$store.state.AgentCode;
    let params = {
      SEARCH_AGENTCODE: this.$store.state.AgentCode,
      SUBJOB: this.$store.state.CHANGE_POSITION.SUBJOB,
      USER_AG_LEVEL: this.$store.state.User_AG_LEVEL
    };

    http.get("AgencyERequest/GetAgentChgPosition?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => { 
      if(res.status == 200) {
        this.AgentPositionCode = res.data.AGENTCODE,
        this.AgentPositionPrename = res.data.PRENAME,
        this.AgentPositionName = res.data.NAME,
        this.AgentPositionSurname = res.data.SURNAME

        this.AgentPositionAGENTTYPE = res.data.AGENTTYPE;
        this.AgentPositionAG_STATUS = res.data.AG_STATUS;
        this.AgentPositionAG_LEVEL = res.data.AG_LEVEL;
        this.AgentPositionAG_STLV_SP = res.data.AG_STLV_SP;
        this.AgentPositionTITLE = res.data.TITLE;

        this.CheckSearch = true;
        this.Loading = false;
      }
      else {

      }
    }).catch((error) => { this.Loading = false; });
  },
  watch: {
    CHG_TYPE(NEW) {
      this.SETPOSITION(NEW);
    },
  },
  methods: {
    Search(val) {
      if(val === '') {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณากรอกรหัสตัวแทนเพื่อค้นหา</label>',
        });
      }
      else {
        this.Loading = true;
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        let params = {
          SEARCH_AGENTCODE: val,
          SUBJOB: this.$store.state.CHANGE_POSITION.SUBJOB,
          USER_AG_LEVEL: this.$store.state.User_AG_LEVEL
        }; 
        http.get("AgencyERequest/GetAgentChgPosition?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => { 
          if(res.status == 200) {
            if(res.data.AGENTCODE == null) {
              Swal.fire({
              icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">ไม่พบข้อมูลตัวแทน</label>',
              });

              this.AgentPositionCode = '';
              this.AgentPositionPrename = '';
              this.AgentPositionName = '';
              this.AgentPositionSurname = '';

              this.AgentPositionAGENTTYPE = '';
              this.AgentPositionAG_STATUS = '';
              this.AgentPositionAG_LEVEL = '';
              this.AgentPositionAG_STLV_SP = '';
              this.AgentPositionTITLE = '';
              
              this.disabled = true;
              this.CheckSearch = false;
              this.Loading = false;
            }
            else {
              this.AgentPositionCode = res.data.AGENTCODE,
              this.AgentPositionPrename = res.data.PRENAME,
              this.AgentPositionName = res.data.NAME,
              this.AgentPositionSurname = res.data.SURNAME

              this.AgentPositionAGENTTYPE = res.data.AGENTTYPE;
              this.AgentPositionAG_STATUS = res.data.AG_STATUS;
              this.AgentPositionAG_LEVEL = res.data.AG_LEVEL;
              this.AgentPositionAG_STLV_SP = res.data.AG_STLV_SP;
              this.AgentPositionTITLE = res.data.TITLE;

              this.CheckSearch = true;
              this.Loading = false;
            }
          }
          else {

          }
        });
      }
    },
    SETPOSITION(CHG_TYPE) {
      this.CHY_POT = null;

      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      
      if(CHG_TYPE !== null && this.AgentCode !== '' && this.CheckSearch) {
        let params = {
          CHG_TYPE: CHG_TYPE,
          AGENTTYPE: this.AgentPositionAGENTTYPE,
          AG_STATUS: this.AgentPositionAG_STATUS, 
          AG_LEVEL: this.AgentPositionAG_LEVEL,
          AG_STLV_SP: this.AgentPositionAG_STLV_SP,
        };

        this.ListPosition = [];

        http.get("AgencyERequest/GetPosition?", { headers: { Authorization: `Bearer ${AuthorizeToken}` }, params }).then((res) => { 
          if(res.status == 200) {

            res.data.forEach((item, index) => {
              let A = {
                id: index,
                label: item.TITLE,
                value: item.AG_POSITION_ID
              };

              this.ListPosition.push(A);
            });
          }
          else {

          }
        });
      }
      else {
        this.CHG_TYPE = null;
        this.ListPosition = [];
          if(this.CHG_TYPE != null) {
            Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตัวแทนใต้สังกัดที่ต้องการดำเนินการ</label>',
          });
        }
      }
    },
    EnterNext() {
      if(this.AgentCode === '' && !this.CheckSearch) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตัวแทนใต้สังกัดที่ต้องการดำเนินการ</label>',
        });
      }
      else if (this.CHG_TYPE ==='' || this.CHG_TYPE == null) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุดำเนินการเพื่อ เพิ่ม หรือลดตำแหน่ง</label>',
        });
      }
      else if(this.CHY_POT === '' || this.CHY_POT == null) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาระบุตำแหน่งใหม่</label>',
        });
      }
      else {
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        let CODE = [];
        CODE.push(this.AgentCode);

        let request = {
          AGENTCODE: CODE,
          SUBJOB: (this.CHG_TYPE === 'PM' ? 'M02' : 'M01'),
        }

        http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => { 
          if(response.status == 200) {
            if(response.data !== '001' && response.data !== '002') {
              this.$store.state.PASS_CHANGE_POSITION.NAME = this.AgentPositionCode + " " + this.AgentPositionPrename + " " + this.AgentPositionName + " " + this.AgentPositionSurname;
              this.$store.state.PASS_CHANGE_POSITION.TITLE = this.AgentPositionTITLE;
              this.$store.state.PASS_CHANGE_POSITION.CHG_TYPE = this.CHG_TYPE;
              this.ListPosition.forEach(item => {
                if(item.value === this.CHY_POT) {
                  this.$store.state.PASS_CHANGE_POSITION.CHG_POT = item.label;
                }
              });
              this.$store.state.PASS_CHANGE_POSITION.MEMO = this.AD_INFO_DETAIL;

              //SET INSERT DATA
              this.$store.state.CHANGE_POSITION.AGENTCODE_CHG = this.AgentCode;
              this.$store.state.CHANGE_POSITION.AD_INFO_DETAIL = this.AD_INFO_DETAIL;
              this.$store.state.CHANGE_POSITION.CHG_TYPE = this.CHG_TYPE;
              this.$store.state.CHANGE_POSITION.SUBJOB = (this.CHG_TYPE === 'PM' ? 'M02' : 'M01');
              this.$store.state.CHANGE_POSITION.AG_POSITION_ID = parseInt(this.CHY_POT);

              this.$router.push('/FinishChangePosition');
            }
            else {
              Swal.fire({
                icon: 'error',
                html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
              });

              this.$router.push("/AgenteService");
            }
          }
        }).catch(() => { 
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">สำหรับผู้บริหารหน่วยดำเนินการเท่านั้น</label>',
          });
        });
      }
    },
    format(val) { 
      this.AgentCode = String(val).padStart(8, '0');
      return this.AgentCode;
    },
  }
};
</script>

<style scoped>
.btn-CB {
  min-height: 50px;
  font-size: 26px;
  font-size: 1.625rem;
  background-color: #0057a8;
}
.border-none:focus {
  outline: none;
}
</style>